<template>
  <div class="norm_table" v-if="norms.length > 0">
    <table>
      <caption class="sr-only">{{ $t('Исполнение законов') }}</caption>
      <thead>
        <tr class="norm_table-th">
          <td role="columnheader">
            {{ $t("№") }}
          </td>
          <td role="columnheader">
            {{ $t("Норма") }}
          </td>
          <td role="columnheader">
            {{ $t('Закон') }}
          </td>
          <td role="columnheader">
            {{ $t("Ответственный гос.орган") }}
          </td>
          <td role="columnheader">
            {{ $t("Автор") }}
          </td>
          <td role="columnheader">
            {{ $t("Срок реализации") }}
          </td>
          <td role="columnheader">
            {{ $t("Тип") }}
          </td>

          <td role="columnheader">
            {{ $t("Наименование подзаконного акта") }}
          </td>
          <td role="columnheader">
            {{ $t("Номер, Дата") }}
          </td>
          <td role="columnheader">
            {{ $t("Действие") }}
          </td>

        </tr>
      </thead>
      <tbody>
        <template
          v-for="(item, index) in norms"
        >
          <template v-if="item.isExecNorm && item.byLaw.length > 0">
            <tr :key="index">
              <td :rowspan="getByRospanLength(item.byLaw)">
                {{ index + 1 }}
              </td>
              <td :rowspan="getByRospanLength(item.byLaw)">

                  <span v-if="item.article">
                    Статья {{item.article.number}}. <span v-if="item.article_part"> Ч.{{item.article_part}}</span>
                  </span>
                  <router-link
                    target="_blank"
                    :to="$i18nRoute({ name: 'law-norm-view', params: { id: item.id }  })"
                  >
                    {{ item.text }}
                  </router-link>
                  <p>
                    <span class="d-block mt-2" v-if="item.law_changes_required && item.law_to_change">
                      <span class="d-block">Требует внесения изменений в закон:</span>
                      <b>{{item.law_to_change.transName}}</b>
                    </span>
                  </p>
              </td>
              <td :rowspan="getByRospanLength(item.byLaw)">
                <router-link
                  target="_blank"
                  :to="{  name: 'law-view', params: { id: item.lawId } }"
                >
                  {{  item.lawName }}
                </router-link>
              </td>

              <td :rowspan="getByRospanLength(item.byLaw)">
                <div
                  v-for="(developer, index) in item.developers"
                  :key="index"
                  class="developer_item"
                >
                  {{ developer.transName }}
                  <span v-if="developer.isMain">
                    <img
                      src="@/assets/icons/checked.png"
                      alt=""
                      aria-hidden="true"
                    />
                  </span>
                </div>
              </td>

              <td :rowspan="getByRospanLength(item.byLaw)">
                {{item.can_view_author ? item.author : '' }}
              </td>

              <td :rowspan="getByRospanLength(item.byLaw)">
                <span v-if="item.implementationPeriod ">
                  {{ new Date(item.implementationPeriod ) | dateFormat('DD.MM.YYYY') }}
                </span>
              </td>

              <template v-if="item.byLaw.length > 0">
                <td>
                  <span v-if="item.byLaw[0].byLawType">
                    {{ item.byLaw[0].byLawType.transName}}
                  </span>
                </td>
                <td class="name_bylaw">
                  <span v-if="item.byLaw[0].zbd_code">
                      <a
                        target="_blank"
                        v-if="currentLocaleUrl == '/ru'"
                        :href="'http://cbd.minjust.gov.kg/act/view/ru-ru/' + item.byLaw[0].zbd_code + '/10'"
                      >
                        {{ item.byLaw[0].transName }}
                      </a>
                      <a
                        v-else
                        target="_blank"
                        :href="'http://cbd.minjust.gov.kg/act/view/ru-ru/' + item.byLaw[0].zbd_code + '/10?cl=ky-kg'"
                      >
                        {{ item.byLaw[0].transName }}
                      </a>
                    </span>
                    <span v-else>
                      {{ item.byLaw[0].transName }}
                  </span>
                </td>
                <td>
                  <span v-if="item.byLaw[0].adoption_date">
                    {{ '№' + item.byLaw[0].number }}, {{ new Date(item.byLaw[0].adoption_date ) | dateFormat('DD.MM.YYYY') }}
                  </span>
                </td>
              </template>
              <td :rowspan="getByRospanLength(item.byLaw)">
                <div
                  class="norm_table-buttons"
                  v-if="permissionToAct && user && (user.roleAdmin || user.roleOperator)"
                >
                    <span
                      role="button"
                      tabindex="0"
                      :aria-label="$t('Редактировать')"
                      @click="normEdit(item.id)"
                      @keyup.enter="normEdit(item.id)"
                      @keyup.space="normEdit(item.id)"
                      class="pro-icon-pencil norm_table-pencil"
                    />

                    <span
                      class="norm_table-remove"
                      role="button"
                      tabindex="0"
                      :aria-label="$t('Удалить')"
                      @click="normRemove(item.id)"
                      @keyup.enter="normRemove(item.id)"
                      @keyup.space="normRemove(item.id)"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </span>
                  </div>
                </td>
            </tr>


            <template v-if="item.byLaw.length > 1">
              <tr
                v-for="itemByLaw in item.byLaw.slice(1)"
                :key="itemByLaw.id"
                :class="{'by-law-null': !item.isExecNorm }"
              >
              <td>
                  <span v-if="itemByLaw.byLawType">
                    {{ itemByLaw.byLawType.transName}}
                  </span>
                </td>
                <td class="name_bylaw">
                  <span v-if="itemByLaw.zbd_code">
                      <a
                        target="_blank"
                        v-if="currentLocaleUrl == '/ru'"
                        :href="'http://cbd.minjust.gov.kg/act/view/ru-ru/' + itemByLaw.zbd_code + '/10?cl=ky-kg'"
                      >
                        {{ itemByLaw.transName }}
                      </a>
                      <a
                        v-else
                        target="_blank"
                        :href="'http://cbd.minjust.gov.kg/act/view/ru-ru/' + itemByLaw.zbd_code + '/10?cl=ky-kg'"
                      >
                        {{ itemByLaw.transName }}
                      </a>
                    </span>
                    <span v-else>
                      {{ itemByLaw.transName }}
                  </span>
                </td>
                <td>
                  <span v-if="itemByLaw.adoption_date">
                    {{ '№' + itemByLaw.number }}, {{ new Date(itemByLaw.adoption_date ) | dateFormat('DD.MM.YYYY') }}
                  </span>
                </td>
              </tr>
            </template>
          </template>
          <template v-else>
            <tr :key="index">
              <td>
                {{ index + 1 }}
              </td>
              <td>
                <p>
                  <span v-if="item.article">
                    Статья {{item.article.number}}. <span v-if="item.article_part"> Ч.{{item.article_part}}</span>
                  </span>
                  <router-link
                    target="_blank"
                    :to="$i18nRoute({ name: 'law-norm-view', params: { id: item.id }  })"
                  >
                    {{ item.text }}
                  </router-link>
                  <span class="d-block mt-2" v-if="item.law_changes_required && item.law_to_change">
                    <span class="d-block">Требует внесения изменений в закон:</span>
                    <b>{{item.law_to_change.transName}}</b>
                  </span>
                </p>
              </td>
              <td>
                <router-link
                  target="_blank"
                  :to="{ name: 'law-view', params: { id: item.lawId } }"
                >
                  {{  item.lawName }}
                </router-link>
              </td>
              <td>
                <div
                  v-for="developer in item.developers"
                  :key="developer"
                  class="developer_item"
                >
                  {{ developer.transName }}
                  <span v-if="developer.isMain">
                    <img
                      src="@/assets/icons/checked.png"
                      alt=""
                      aria-hidden="true"
                    />
                  </span>
                </div>
              </td>
              <td :rowspan="getByRospanLength(item.byLaw)">
                {{item.can_view_author ? item.author : '' }}
              </td>
              <td>
                <span v-if="item.implementationPeriod ">
                  {{ new Date(item.implementationPeriod ) | dateFormat('DD.MM.YYYY') }}
                </span>
              </td>
              <td colspan="3">
                <span v-if="item.executionNorm && item.executionNorm.id == 1">
                  {{ item.executionNorm.transName }}
                </span>
                <span v-if="item.last_norm_stage">
                  {{ item.last_norm_stage.transName }}
                </span>
              </td>

              <td>
                <div
                  class="norm_table-buttons"
                  v-if="permissionToAct && user && (user.roleAdmin || user.roleOperator)"
                >
                    <span
                      role="button"
                      tabindex="0"
                      :aria-label="$t('Редактировать')"
                      @click="normEdit(item.id)"
                      @keyup.enter="normEdit(item.id)"
                      @keyup.space="normEdit(item.id)"
                      class="pro-icon-pencil norm_table-pencil"
                    />

                    <span
                      class="norm_table-remove"
                      role="button"
                      tabindex="0"
                      :aria-label="$t('Удалить')"
                      @click="normRemove(item.id)"
                      @keyup.enter="normRemove(item.id)"
                      @keyup.space="normRemove(item.id)"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </span>
                  </div>
                </td>
          </tr>

          </template>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>

import LAW from '@/model/law'

export default {
  name: 'LawNormTable',
  props: {
    norms: {
      type: Array,
      required: true
    },
    developers: {
      type: Array,
      required: true
    },
    permissionToAct: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    user() {
      return this.$store.state.getNpaData.currentUser
    },
  },

  methods: {
    sendLawView (id) {
      this.$router.push({
        name: 'law-view',
        params: {
          id: id
        }
      })
    },

    normEdit(id) {
      this.$router.push({
        name: 'edit-norm',
        params: {
          id: id
        }
      })
    },

    getByRospanLength (byLaw) {
      if (byLaw.length == 0) {
        return 1
      }

      return byLaw.length
    },

    normRemove(id) {
      const confirmed = confirm("Вы действительно хотите удалить норму?");

      if (confirmed) {
        LAW.removeNorm(id).then((response) => {
          this.$emit('remove', id);
        }).catch((error) => {
          console.error("Ошибка при удалении:", error);
        });
      } else {
        console.log("Удаление отменено.");
      }
    },
    getDeveloper(developerId) {
      if (this.developers == null) {
        return null
      }

      let developer = this.developers.find(item => item.id == developerId)

      if (!developer) {
        return null
      }
      return developer.transName
    }
  }
}
</script>
<style lang="scss" scoped>
  .norm_table {
    padding-top: 20px;

    &-remove {
      margin-left: 10px;
      cursor: pointer;
    }

    &-pencil {
      cursor: pointer;
    }

    &-th {
      background-color: #dadada;
    }

    table {
      th {
        padding: 0;
        border:none;
      }

      td {
        vertical-align: top
      }

      td:first-child {
        max-width: 60px;
      }

      td:nth-child(9) {
        width: 60px;
      }

      td:nth-child(6) {
        max-width: 100px;
      }

      .name_bylaw:nth-child(7) {
        min-width: 300px;
      }
    }
  }

  .by-law-null {
    font-weight: 600;
  }

  .developer_item {
    padding-bottom: 20px;

    img {
      width: 20px;
      height: 20px;
    }
  }
</style>
